module.exports = __webpack_public_path__ + "static/media/preference-profession-decor-lover.1232c515.png";